import React, { useContext, useEffect } from "react";

import Modal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import SaveSpinnerButton from "./save_spinner_button";
import useCompanyUpdateApi from "../data/use_company_update_api";
import { CompanyContext } from "../data/company_context_management";

function MainContentForm() {
  const { register, handleSubmit, control, setValue } = useForm();
  const context = useContext(CompanyContext);
  const { company, isUpdating, setOpenEditModal, generalError, setGeneralError } = context;
  const { updateCompany } = useCompanyUpdateApi({ ...context });

  useEffect(() => {
    setValue("show_prs", company.page_config?.show_prs);
    setValue("show_brands", company.page_config?.show_brands);
  }, [company, setValue]);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const onSubmit = async (data, event) => {
    /* eslint-disable camelcase */
    event.preventDefault();

    const { show_prs, show_brands, ...otherData } = data;

    const pageConfig = {
      ...company.page_config,
      show_prs,
      show_brands,
    };

    updateCompany({ ...otherData, page_config: pageConfig });
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="pt-3">
          <div className="mb-3 row">
            <label htmlFor="description" className="col-sm-3 col-form-label">
              About Us
            </label>
            <div className="col-sm-9">
              <textarea
                id="description"
                className="form-control"
                {...register("description")}
                disabled={isUpdating}
                defaultValue={company.description}
                rows={5}
                placeholder="Riverstone Analytics helps mid-sized retailers turn everyday data into smarter decisions. Founded in 2015, we serve more than 300 brands across North America, pairing plain-English insights with software teams actually use."
              />
              {generalError && generalError.error?.body?.errors?.some((e) => e.source === "description") && (
                <p className="text-danger">
                  {generalError.error.body.errors.find((e) => e.source === "description").detail}
                </p>
              )}
            </div>
          </div>
          {company.displayType === "pr_firm" && (
            <div className="mb-3 row">
              <div className="col-sm-3">Optional Tabs</div>
              <div className="form-check form-switch col-sm-9 ps-5">
                <label className="form-check-label" htmlFor="show_pr_users">
                  Show the &quot;Our PR Team&quot; tab
                  <input
                    type="checkbox"
                    className="form-check-input"
                    disabled={isUpdating}
                    id="show_prs"
                    defaultChecked={company.page_config?.show_prs}
                    onChange={(e) => setValue("show_prs", e.target.checked)}
                  />
                </label>
                <Controller
                  control={control}
                  name="show_prs"
                  render={({ field }) => <input type="hidden" {...field} />}
                />
              </div>
            </div>
          )}
          {company.displayType === "pr_firm" && (
            <div className="mb-3 row">
              <div className="col-sm-3">&nbsp;</div>
              <div className="form-check form-switch col-sm-9 ps-5">
                <label className="form-check-label" htmlFor="show_brands">
                  Show the &quot;Our Brands&quot; tab
                  <input
                    type="checkbox"
                    className="form-check-input"
                    disabled={isUpdating}
                    id="show_brands"
                    defaultChecked={company.page_config?.show_brands}
                    onChange={(e) => setValue("show_brands", e.target.checked)}
                  />
                </label>
                <Controller
                  control={control}
                  name="show_brands"
                  render={({ field }) => <input type="hidden" {...field} />}
                />
              </div>
            </div>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <SaveSpinnerButton
          inactiveText="Save Changes"
          activeText="Saving..."
          isSaving={isUpdating}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
        <button type="button" className="btn text-danger" onClick={closeModal} disabled={isUpdating}>
          Cancel
        </button>
      </Modal.Footer>
    </>
  );
}

export default MainContentForm;
